/**
 * @generated SignedSource<<f40d22f91f3de370a735fe74dfea956c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileInfo_profile$data = {
  readonly activities: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
    } | null | undefined>;
  };
  readonly age: number | null | undefined;
  readonly beliefSystem: {
    readonly name: string;
  } | null | undefined;
  readonly biography: string | null | undefined;
  readonly childrenPreference: {
    readonly name: string;
  } | null | undefined;
  readonly closestCity: string | null | undefined;
  readonly deets: {
    readonly nodes: ReadonlyArray<{
      readonly isOther: boolean;
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  };
  readonly educationLevel: {
    readonly name: string;
  } | null | undefined;
  readonly gender: {
    readonly name: string;
  } | null | undefined;
  readonly genderOther: string | null | undefined;
  readonly heightCm: number | null | undefined;
  readonly heightFt: number | null | undefined;
  readonly heightIn: number | null | undefined;
  readonly occupation: string | null | undefined;
  readonly politicalView: {
    readonly name: string;
  } | null | undefined;
  readonly pronoun: {
    readonly name: string;
  } | null | undefined;
  readonly relationshipInterests: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
    } | null | undefined>;
  };
  readonly school: string | null | undefined;
  readonly user: {
    readonly userDeets: {
      readonly nodes: ReadonlyArray<{
        readonly deetId: any;
        readonly other: string | null | undefined;
      } | null | undefined>;
    };
    readonly userPrompts: {
      readonly nodes: ReadonlyArray<{
        readonly answer: string;
        readonly prompt: {
          readonly question: string;
        } | null | undefined;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly userId: any;
  readonly vaccinationStatus: {
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "ProfileInfo_profile";
};
export type ProfileInfo_profile$key = {
  readonly " $data"?: ProfileInfo_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileInfo_profile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileInfo_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityConnection",
      "kind": "LinkedField",
      "name": "activities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Activity",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v1/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "age",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BeliefSystem",
      "kind": "LinkedField",
      "name": "beliefSystem",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "biography",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChildrenPreference",
      "kind": "LinkedField",
      "name": "childrenPreference",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closestCity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DeetConnection",
      "kind": "LinkedField",
      "name": "deets",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Deet",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            },
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isOther",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EducationLevel",
      "kind": "LinkedField",
      "name": "educationLevel",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Gender",
      "kind": "LinkedField",
      "name": "gender",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "genderOther",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "heightCm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "heightFt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "heightIn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "occupation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PoliticalView",
      "kind": "LinkedField",
      "name": "politicalView",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Pronoun",
      "kind": "LinkedField",
      "name": "pronoun",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RelationshipTypeConnection",
      "kind": "LinkedField",
      "name": "relationshipInterests",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RelationshipType",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v1/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "school",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserDeetConnection",
          "kind": "LinkedField",
          "name": "userDeets",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserDeet",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deetId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "other",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "UserPromptConnection",
          "kind": "LinkedField",
          "name": "userPrompts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserPrompt",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "answer",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Prompt",
                  "kind": "LinkedField",
                  "name": "prompt",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "question",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "userPrompts(orderBy:[\"SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VaccinationStatus",
      "kind": "LinkedField",
      "name": "vaccinationStatus",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "Profile",
  "abstractKey": null
};
})();

(node as any).hash = "83853eb2179d33948b00647265a0c5b5";

export default node;
